import { getCurrentSchoolYearStartYear } from "../common/schoolYear";

const MONTH_NAMES = [
  "styczen",
  "luty",
  "marzec",
  "kwiecien",
  "maj",
  "czerwiec",
  "lipiec",
  "sierpien",
  "wrzesien",
  "pazdziernik",
  "listopad",
  "grudzien",
];

function formatMonthValue(year, monthIndex) {
  return `${year}-${String(monthIndex + 1).padStart(2, "0")}`;
}

function getLastVisibleMonth(schoolYearRange, today) {
  if (schoolYearRange.startYear === getCurrentSchoolYearStartYear(today)) {
    return {
      year: today.getFullYear(),
      monthIndex: today.getMonth(),
    };
  }

  return {
    year: schoolYearRange.startYear + 1,
    monthIndex: 7,
  };
}

function buildSchoolYearMonthOptions(schoolYearRange, today = new Date()) {
  const options = [];
  const lastVisibleMonth = getLastVisibleMonth(schoolYearRange, today);
  let year = schoolYearRange.startYear;
  let monthIndex = 8;

  while (year < lastVisibleMonth.year || (year === lastVisibleMonth.year && monthIndex <= lastVisibleMonth.monthIndex)) {
    options.push({
      value: formatMonthValue(year, monthIndex),
      text: `${MONTH_NAMES[monthIndex]} ${year}`,
    });

    monthIndex += 1;

    if (monthIndex === 12) {
      monthIndex = 0;
      year += 1;
    }
  }

  return options.reverse();
}

export default buildSchoolYearMonthOptions;
